// extracted by mini-css-extract-plugin
export default {"list":"ListOfAlbums_list__JEjIt","editOrderAlbums":"ListOfAlbums_editOrderAlbums__8Fy37","test":"ListOfAlbums_test__bhMIT"};